import { render } from "./Date.vue?vue&type=template&id=2d0643bd"
import script from "./Date.vue?vue&type=script&lang=js"
export * from "./Date.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__